module.exports = __webpack_public_path__ + "img/events-light.3a2e6abd.svg";